import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './theme/tailwind.css';
import { initDeepLinks } from './lib/auth/deepLinks';

initDeepLinks();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
